import {
  ReflectionsIndexSchema,
  ThreadsIndexSchema,
  type GuidedThread,
  type ReflectionsIndex,
  type ThreadsIndex,
} from './schema';

async function loadJson(url: string): Promise<unknown> {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(
      `Guided study data request failed with status ${String(response.status)}.`,
    );
  }
  return response.json();
}

export async function loadThreads(conferenceId: string): Promise<ThreadsIndex> {
  return ThreadsIndexSchema.parse(
    await loadJson(`/data/conference/${encodeURIComponent(conferenceId)}/threads.json`),
  );
}

export async function loadReflections(conferenceId: string): Promise<ReflectionsIndex> {
  return ReflectionsIndexSchema.parse(
    await loadJson(`/data/conference/${encodeURIComponent(conferenceId)}/reflections.json`),
  );
}

export function allThreads(index: ThreadsIndex): GuidedThread[] {
  return [
    ...index.themeThreads,
    ...index.verseThreads,
    ...index.speakerThreads,
  ];
}

export function findThread(
  index: ThreadsIndex,
  threadId: string,
): GuidedThread | undefined {
  return allThreads(index).find((thread) => thread.threadId === threadId);
}
